<template>
	<b-container fluid>
		<b-row>
			<b-col cols lg="12">
				<b-breadcrumb class="text-lg-left" :items="breadcrumb" style="margin-top: 15px;"></b-breadcrumb>
			</b-col>
		</b-row>
		<b-row>
			<b-col cols lg="10" style="padding-bottom:20px;">
				<b-card bg-variant="light" style="margin-top: 15px;">
					<b-form>
						<h2 class="title">{{$lang.finnance.invoices.new}}</h2>
						<hr>

						<b-alert :show="errorMessages.length > 0" variant="danger" dismissible>
							{{this.$lang.errors.errorLabel}}
							<ul style="margin-bottom: 0px;">
								<li v-for="(errorMessage, index) in errorMessages" :key="index">
									{{errorMessage}}
								</li>
							</ul>
						</b-alert>
                        <div style="margin-bottom: 10px;">
							<label for="invoice.purchaseOrderNumber" class="col-form-label">{{$lang.finnance.purchaseOrders.number}}</label>
							<b-input-group >
								<b-form-input v-model="invoice.purchaseOrderNumber"
                                    required
                                    disabled
                                    :placeholder="$lang.finnance.purchaseOrders.number" />
							</b-input-group>
						</div>
                        <div style="margin-bottom: 10px;">
							<label for="invoice.costCenterName" class="col-form-label">{{$lang.contract.costCenter}}</label>
							<b-input-group >
								<b-form-input v-model="invoice.costCenterName"
                                    required
                                    disabled
                                    :placeholder="$lang.contract.costCenter" />
							</b-input-group>
						</div>
                        <div style="margin-bottom: 10px;">
							<label for="invoice.providerName" class="col-form-label">{{$lang.settings.providers.label}}</label>
							<b-input-group >
								<b-form-input v-model="invoice.providerName"
                                    required
                                    disabled
                                    :placeholder="$lang.settings.providers.label" />
							</b-input-group>
						</div>
                        <div style="margin-bottom: 10px;">
							<label for="invoice.number" class="col-form-label">{{$lang.finnance.invoices.number}}</label>
							<b-input-group >
								<b-form-input v-model="invoice.number"
                                    required
                                    :placeholder="$lang.finnance.invoices.number" />
							</b-input-group>
						</div>
						<b-row style="margin-bottom: 10px;">
							<b-col cols lg="8">
								<label for="invoice.invoiceDate">{{$lang.finnance.purchaseOrders.invoiceDate}}</label>
								<date-pick v-model="invoice.invoiceDate" class="blockDatePick" :format="dateFormat" :input-attributes="{ class: 'form-control'}" :change="getPaymentDate()"></date-pick>
							</b-col>
							<b-col>
								<label for="invoice.paymentDate">{{$lang.finnance.invoices.paymentDate}}</label>
								<date-pick v-model="invoice.paymentDate" class="blockDatePick" :format="dateFormat" :input-attributes="{ class: 'form-control', disabled: true}"></date-pick>
							</b-col>
						</b-row>
						<div style="z-index: -9999">
                            <label for="invoice.shippingDocument">{{$lang.finnance.invoices.attachShippingDocument}}</label>
                            <b-form-file
									style="z-index: 1"
									id="shippingDocument"
                                    v-model="invoice.shippingDocument"
                                    :state="Boolean(invoice.shippingDocument)"
                                    :placeholder="$lang.finnance.invoices.attachmentPlaceholder"
                                    :drop-placeholder="$lang.finnance.invoices.dropFilePlaceholder"
                                    :browse-text="$lang.common.search"
                                ></b-form-file>
                                <div class="mt-1">{{$lang.finnance.invoices.attachedInvoice}}: {{ invoice.shippingDocument ? invoice.shippingDocument.name : $lang.common.notAvailable }}</div>
                        </div>
                        <div class="mt-3" >
                            <label for="invoice.invoiceDocument">{{$lang.finnance.invoices.attachInvoice}}</label>
                            <b-form-file
									style="z-index: 1"
									id="invoiceDocument"
                                    v-model="invoice.invoiceDocument"
                                    :state="Boolean(invoice.invoiceDocument)"
                                    :placeholder="$lang.finnance.invoices.attachmentPlaceholder"
                                    :drop-placeholder="$lang.finnance.invoices.dropFilePlaceholder"
                                    :browse-text="$lang.common.search"
                                ></b-form-file>
                                <div class="mt-1">{{$lang.finnance.invoices.attachedInvoice}}: {{ invoice.invoiceDocument ? invoice.invoiceDocument.name : $lang.common.notAvailable }}</div>
                        </div>
                        <hr>
						<h4 class="title">{{$lang.settings.materials.title}}</h4>
						<div style="margin-top:25px;"></div>
						<b-row v-for="(product, index) in invoice.products" :key="index">
							<b-col lg="1">
								<div class="form-division" style="">
									<strong>#{{ index + 1 }}</strong>
                                    <p-check class="p-switch p-fill" style="margin-top: 12px; margin-left: 5px;" color="info" v-model="product.invoiced" ></p-check>
								</div>
							</b-col>
                            <b-col lg="3">
                                <label for="product.name"><strong>{{$lang.settings.providers.materials.name}}</strong></label>
								<div class="form-division" style="">
									{{product.name}}
								</div>
							</b-col>
                            <b-col lg="2">
								<label for="product.quantity"><strong>{{$lang.settings.providers.materials.quantity}}</strong></label>
								<div class="form-division" style="">
									{{formatNumber(product.quantity)}}
								</div>
							</b-col>
							<b-col lg="2">
								<label for="product.quantityInvoiced"><strong>{{$lang.settings.providers.materials.quantityInvoiced}}</strong></label>
								<money v-model="product.quantityInvoiced" v-bind="price" class="form-control" @blur="calculateTotals()" :disabled="product.invoiced == false"></money>
								<!-- <div class="form-division" style="">
									{{formatNumber(product.quantity)}}
								</div> -->
							</b-col>
                            <b-col lg="2">
								<label for="product.price"><strong>{{$lang.settings.providers.materials.price}}</strong></label>
								<div class="form-division" style="">
									{{formatNumber(product.price)}}
								</div>
							</b-col>
                            <b-col lg="2">
								<label for="product.quantity"><strong>{{$lang.finnance.purchaseOrders.total}}</strong></label>
								<div class="form-division" style="">
									{{formatNumber(product.price * product.quantityInvoiced)}}
								</div>
							</b-col>
                        </b-row>
					</b-form>
				</b-card>
			</b-col>
			<b-col cols lg="2" style="padding-top: 15px;">
				<b-card class="sideButtons" bg-variant="light">
					<b-button variant="primary" class="title" block value="Save" v-on:click="createInvoice"  >{{$lang.buttons.save}}</b-button>
					<b-button variant="danger"  class="title" block value="Cancel" @click="goToListScreen()">{{$lang.buttons.back}}</b-button>
					<hr>
				</b-card>
			</b-col>
        </b-row>
	</b-container>
</template>

<script>
import DatePick from 'vue-date-pick'
// import { Money } from 'v-money'
import moment from 'moment'

const utils = require('../../../utils.js');

export default {
	data() {
		return {
            dateFormat: utils.dateFormat,
            date: moment().format(utils.dateFormat),
			price: {... utils.moneyConfig, precision: 2},
			validForm: true,
			errorMessages: [],
            // purchaseOrder: {},
            invoice: {
                purchaseOrderNumber: '',
                costCenterCode: '',
                costCenterName: '',
                providerCode: '',
                providerName: '',
                invoiceDate: '',
                products: [],
				// invoiceDocument: [],
				// shippingDocument: []
            },
			breadcrumb: [{'text': this.$lang.modules.finnance,'to': '/'},{'text': this.$lang.finnance.invoices.title,'to': '/finnance/invoices'}, {'text': 'Factura', 'href': '#'}],
		}
	},
	components: {
		// Money,
		DatePick,
	},
	methods:{
        createInvoice() {
			this.validateInvoice()

			if (this.validForm == true) {
				this.$store.dispatch('createInvoice', this.invoice)
			}
			// this.$router.push('/computingMetrics')
        },
		goToListScreen() {
			this.$router.push({name: 'PurchaseOrders'})
			// this.$router.go()
		},
		validateInvoice() {
			this.validForm = true
			this.errorMessages = []

			if (this.invoice.number == '' || this.invoice.number == undefined) {
				this.validForm = false;
				this.errorMessages.push(this.$lang.errors.invoiceNumber)
			}

			if (this.invoice.invoiceDate == '' || this.invoice.invoiceDate == undefined) {
				this.validForm = false
				this.errorMessages.push(this.$lang.errors.invoiceDate)
			}

			if (this.invoice.shippingDocument == '' || this.invoice.shippingDocument == undefined) {
				this.validForm = false
				this.errorMessages.push(this.$lang.errors.shippingDocument)
			}

			if (this.invoice.invoiceDocument == '' || this.invoice.invoiceDocument == undefined) {
				this.validForm = false
				this.errorMessages.push(this.$lang.errors.invoiceDocument)
			}

			let minimunProductsInvoiced = false
			this.invoice.products.forEach((product, index) => {
				if (product.invoiced == true) {
					minimunProductsInvoiced = true

					if (product.quantityInvoiced == 0) {
						this.errorMessages.push(this.$lang.errors.zeroQuantityInvoiced + '. ' + this.$lang.settings.providers.materials.material + ' #' + (index+1))
					} else if (product.quantityInvoiced > product.quantity) {
						this.validForm = false
						this.errorMessages.push(this.$lang.errors.quantityInvoiced + '. ' + this.$lang.settings.providers.materials.material + ' #' + (index+1))
					}
				}
			})

			if (minimunProductsInvoiced == false) {
				this.validForm = false
				this.errorMessages.push(this.$lang.errors.minimunProductsInvoiced)
			}
			console.log(this.errorMessages)
		},
		getPaymentDate() {
			if (this.invoice.invoiceDate != '' && this.invoice.invoiceDate != undefined) {
				let invoiceDate = moment(this.invoice.invoiceDate, utils.dateFormat).add({days: 30})
				let dayInvoiced = parseInt(moment(invoiceDate, utils.dateFormat).format('DD'))
				let monthInvoiced = parseInt(moment(invoiceDate, utils.dateFormat).format('MM'))
				let yearInvoiced = parseInt(moment(invoiceDate, utils.dateFormat).format('YYYY'))

				if (dayInvoiced >= '10' && dayInvoiced <= '24') {
					dayInvoiced = 25
				}
				else if (dayInvoiced >= '1' && dayInvoiced < '10') {
					dayInvoiced = 10
				}
				else if (dayInvoiced >= '25' && dayInvoiced <= "31") {
					dayInvoiced = 10
					if (monthInvoiced == 12) {
						monthInvoiced = 1
						yearInvoiced += 1
					} else {
						monthInvoiced += 1
					}
				}

				this.invoice.paymentDate = moment(dayInvoiced + '/' + monthInvoiced + '/' + yearInvoiced, utils.dateFormat).format(utils.dateFormat)
				console.log(this.invoice.paymentDate)
			}
		},
		calculateTotals() {

		},
		formatNumber: utils.formatNumber
	},
	created() {
		this.$Progress.start()

        var purchaseOrderId = this.$route.params.purchaseOrderId;

        this.$store.dispatch('fetchPurchaseOrder', { purchaseOrderId }).then(() => {
            let purchaseOrder = this.$store.getters.purchaseOrder
            this.invoice.purchaseOrderNumber = purchaseOrder.orderNumber
            this.invoice.costCenterName = purchaseOrder.costCenter.name
            this.invoice.costCenterCode = purchaseOrder.costCenter.code
            this.invoice.providerName = purchaseOrder.provider.name
            this.invoice.providerCode = purchaseOrder.provider.code
            this.invoice.products = purchaseOrder.products
			this.invoice.purchaseOrderId = purchaseOrderId
        })
		// if(this.$route.params.purchaseOrderId) {
		// 	let purchaseOrderId = this.$route.params.purchaseOrderId
		// 	this.$store.dispatch('fetchPurchaseOrder', { purchaseOrderId }).then( () => {
		// 		this.purchaseOrder = this.$store.getters.purchaseOrder;
		// 		this.calculateTotals()
		// 	} )
		// }

		// this.$store.dispatch('fetchProviders')
		// this.$store.dispatch('fetchCostCenters')
		// this.$store.dispatch('fetchPurchaseOrderStatuses')

		this.$Progress.finish();
	},
	// updated() {
	// 	this.checkDates()
	// }
}
</script>

<style scoped>
.custom-file-input:lang(en) ~ .custom-file-label::after {
    content: 'Buscar' !important;
}
</style>